module.exports = __webpack_public_path__ + "img/malaysia.f4c3b770.svg";